// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"PvSidebar_sidebar__jFIsM","sidebar-item":"PvSidebar_sidebar-item__2q1Wi","active":"PvSidebar_active__2f-jV","list":"PvSidebar_list__o59Ff"};